module.exports = __webpack_public_path__ + "img/v3.99e08cad.png";